var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1165 0.5C19.913 0.5 20.5941 1.17952 20.5941 2.0625V14.4375C20.5941 15.3205 19.913 16 19.1165 16H7.2511C6.45465 16 5.77353 15.3205 5.77353 14.4375V2.0625C5.77353 1.17952 6.45465 0.5 7.2511 0.5H19.1165ZM3.45515 14.4375C3.45515 16.5891 5.13796 18.375 7.2511 18.375H15.3206V19.9375C15.3206 20.8205 14.6395 21.5 13.843 21.5H1.97757C1.18112 21.5 0.5 20.8205 0.5 19.9375V7.5625C0.5 6.67952 1.18112 6 1.97757 6H3.45515V14.4375Z",
    stroke: "#BF96FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3fab4f9dd7384f491f522454d46a308c.svg";
export { ForwardRef as ReactComponent };